import React, { useState } from "react";
import Modal from "@components/Modal/Modal";

import styles from "./BuyButton.module.css";
import "./BuyButton.css";

const BuyButton = ({ retailerModalHtml, isTablet }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <a
        className={[styles["anch"], styles["button"], "button", styles["dynamic-btn"]].join(" ")}
        rel="noopener nofollow sponsored"
        onClick={() => setIsModalOpen(true)}
      >
        Buy Now
      </a>
      <div className={[styles["retailer-modal"], isModalOpen ? [styles["visible"], "visible"].join(" ") : [styles["hidden"], "hidden"].join(" ")].join(" ")}>
        {
          <Modal
            isOpen={true}
            closeBtn={() => setIsModalOpen(false)}
            sizeClass={"long"}
            className={"newsletter-modal"}
            transitionName={"modal-anim"}
          >
            {retailerModalHtml}
          </Modal>
        }
      </div>
    </>
  );
};

export default BuyButton;
